/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryHook} from '../types'
import {getBrandSitemap} from '../api'

 export const useQueryGetBrandSitemap = createReactQueryHook('getBrandSitemap', getBrandSitemap)
